import { CoreComponent, getLocalToken, verifyUID  } from "@reco-m/core";
import { bootstrapAuthIntegrity } from "./auth-integrity"

/**
 * 认证门禁状态管理器（模块内单例、不挂 window，仅防控制台单独改写 isAuth 返回值）
 */
class AuthGateManager {
    private authGate = false;
    private sessionReadyAt: number | null = null;

    /** 根据认证结果更新门禁状态 */
    setAuthed(ok: boolean): void {
        if (ok) {
            this.authGate = true;
            this.sessionReadyAt = Date.now();
        } else {
            this.reset();
        }
    }

    /** 门禁是否处于有效认证态 */
    isGateValid(): boolean {
        return this.authGate && this.sessionReadyAt !== null;
    }

    /** 重置门禁状态 */
    reset(): void {
        this.authGate = false;
        this.sessionReadyAt = null;
    }
}

/** 模块内私有单例，不对外导出 */
const authGateManager = new AuthGateManager();

export function isAnonymous() {
    return !getLocalToken();
}


/**
 * 判断当前是否已认证（兼容原有逻辑，同步更新门禁状态）
 */
export function isAuth() {
    const ok = !!getLocalToken() || verifyUID();
    authGateManager.setAuthed(ok);
    return ok;
}
/**
 * 页面级认证门禁（须先经 isAuth 写入门禁，再校验门禁有效）。
 * 无法抵御 Burp/代理替换整包 JS：攻击者可一并改掉本函数与 AuthGateManager。
 * 真正鉴权依赖 HttpClient.verifyAuth + 接口侧 token 校验（401）。
 */
export function checkAuthAndRedirect(redirectCallback?: () => void): boolean {
    const authResult = isAuth();
    const isValid = authResult && authGateManager.isGateValid();

    if (!isValid) {
        authGateManager.reset();
        redirectCallback?.();
        return false;
    }
    return true;
}


CoreComponent.Base.prototype.isAuth = function() {
    return checkAuthAndRedirect();
}

/** 全局单点：认证函数完整性巡检（与子类实例数量无关） */
if (window["client"]?.enableAuthIntegrity) {
    bootstrapAuthIntegrity(checkAuthAndRedirect, () => CoreComponent.Base.prototype.isAuth);
}
